/**
 * It will create a promise that will resolve
 * after `seconds` seconds returning `data`
 * @param seconds
 * @param data
 * @returns {Promise<void>}
 */
export function delay<T = void>(seconds: number, data?: T): Promise<T> {
    return new Promise<T>((res: (T) => void) => setTimeout(res, seconds * 1000, data));
}
